import { render } from "./profile-details.vue?vue&type=template&id=8e0f7da4&scoped=true&lang=pug"
import script from "./profile-details.vue?vue&type=script&lang=js"
export * from "./profile-details.vue?vue&type=script&lang=js"

import "./profile-details.vue?vue&type=style&index=0&id=8e0f7da4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e0f7da4"]])

export default __exports__